import { Injectable } from '@angular/core';
import { AResourceService } from './a-resource.service';
import { CustomerModel } from '../../models/resources/customer.model';
import { UrlParamModel } from '../../models/url-param.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerService extends AResourceService<CustomerModel> {
  constructor() {
    super('/customers', true, ['parent', 'children']);
  }

  /**
   * Listen zeigen nur Hauptdatensätze (keine Kontakte/Child-Kunden) –
   * betrifft Kundenliste, Parent-Auswahl und die Kunden-Auswahl bei Schnittstellen.
   * Kontakte werden über den Kontakte-Tab des jeweiligen Kunden verwaltet.
   */
  protected override getDefaultListParams(): UrlParamModel[] {
    return [{ key: 'only-main', value: 'true' }];
  }
}
